import { registerPlugin } from '@capacitor/core';

/**
 * Puente TypeScript del plugin nativo `RoisCredentials`
 * (`android/app/src/main/java/com/insolite/rois/credentials/`).
 *
 * Existe porque el WebView de Android no tiene gestor de contraseñas: el
 * "¿Guardar contraseña?" del navegador es de Chrome, no del WebView. El porqué
 * de haber ido por Credential Manager y no por Autofill —y el peligro de
 * cambiar el origen del WebView— está en el javadoc del plugin.
 *
 * Ningún método rechaza cuando el operario dice que no: cancelar es una
 * respuesta, no un fallo. El motivo viaja en `reason`.
 */

/** Por qué terminó el intento de guardar. */
export type SaveCredentialReason = 'saved' | 'cancelled' | 'error';

/** Por qué terminó el intento de recuperar. */
export type GetCredentialReason = 'found' | 'none' | 'cancelled' | 'error';

export interface SaveCredentialResult {
  saved: boolean;
  reason: SaveCredentialReason;
}

export type GetCredentialResult =
  | { found: true; reason: 'found'; username: string; password: string }
  | { found: false; reason: Exclude<GetCredentialReason, 'found'> };

export interface RoisCredentialsPlugin {
  /**
   * Ofrece guardar la credencial en el gestor del sistema. Llamar SOLO tras un
   * login correcto — guardar una contraseña que el backend acaba de rechazar
   * envenenaría el gestor.
   */
  save(options: {
    username: string;
    password: string;
  }): Promise<SaveCredentialResult>;

  /**
   * Abre el selector del sistema para elegir una credencial guardada. Si no
   * hay ninguna resuelve `found:false` con `reason:'none'`, sin UI.
   */
  get(): Promise<GetCredentialResult>;
}

export const RoisCredentials =
  registerPlugin<RoisCredentialsPlugin>('RoisCredentials');

export default RoisCredentials;
